import Language, { notifyTranslationsLoaded } from '@/utils/Language';

const loadedByLang = {};

const ensureLoaded = (locale) => {
  if (loadedByLang[locale] !== undefined) return;
  loadedByLang[locale] = null;
  Promise.all([
    import(`@/assets/i18n/allHome/${locale}.json`),
    import(`@/assets/i18n/properties/${locale}.json`),
    import(`@/assets/i18n/tags/${locale}.json`),
    import(`@/assets/i18n/ui/${locale}.json`),
    import('@/assets/i18n/languages/default.json'),
    import(`@/assets/i18n/languages_translated/${locale}.json`)
  ])
    .then(([allHome, properties, tags, ui, languages, languagesTranslated]) => {
      loadedByLang[locale] = {
        ...allHome.default,
        ...properties.default,
        ...tags.default,
        ...ui.default,
        ...languages.default,
        ...languagesTranslated.default
      };
      notifyTranslationsLoaded();
    })
    .catch(() => {
      delete loadedByLang[locale];
    });
};

if (typeof window !== 'undefined') {
  ensureLoaded(Language.getCurrentLanguage().replace('-', '_'));
}

const t = (text, vars = null) => {
  const locale = Language.getCurrentLanguage().replace('-', '_');
  ensureLoaded(locale);
  const data = loadedByLang[locale] || loadedByLang['en'] || {};
  if (vars?.answers?.userType && data?.[vars.answers.userType]?.[text]) {
    return Language.t(data[vars.answers.userType], text, vars);
  }
  return Language.t(data, text, vars);
};

export default t;
